/* eslint-disable max-len */
import EaTakeover from '@propertypal/shared/src/resources/icons/products/ea-homepage-takeover-icon.svg';
import EaWebsite from '@propertypal/shared/src/resources/icons/products/ea-websites-icon.svg';
import EaWhyTraffic from '@propertypal/shared/src/resources/icons/products/why-traffic-icon.svg';
import TakeoverMockup from '@propertypal/shared/src/resources/images/homepage-takeover/ea-homepage-takeover-mockup.png';
import React from 'react';
import ProductsPageHeader, { ProcutsHeaderIcon } from '../headers/products/ProductsPageHeader';
import ProductScreenTabs, { ProductScreenTab } from './ProductScreenTabs';

const tabs: ProductScreenTab[] = [
  {
    title: 'Maximise your exposure',
    text: `Get more exposure by being featured on the homepage of Northern Ireland's number one property portal`,
    maxW: 420,
  },
  {
    title: 'Showcase your brand',
    text: `Display your message and brand in front of 1.3 million monthly visitors to PropertyPal - perfect for a high impact launch`,
    maxW: 470,
  },
  {
    title: 'Engage The Audience',
    text: `Use High Definition video to exhibit your development to the audience`,
    maxW: 310,
  },
];

const icons: ProcutsHeaderIcon[] = [
  {
    SVG: EaTakeover,
    heading: '1.3 million',
    text: `active users monthly`,
    maxW: 200,
  },
  {
    SVG: EaWhyTraffic,
    heading: '5.75 million',
    text: `website sessions monthly`,
    maxW: 240,
  },
  {
    SVG: EaWebsite,
    heading: '155 million',
    text: `page views monthly`,
    maxW: 190,
  },
];

interface HomepageTakeoverProps {
  dev?: boolean;
}

const HomepageTakeover: React.FC<HomepageTakeoverProps> = ({ dev }) => {
  return (
    <>
      <ProductsPageHeader
        title="Homepage Takeover"
        text={dev ? 'Showcase your development on our homepage' : 'Take pride of place on the PropertyPal homepage.'}
        headingProps={{ mb: 10 }}
        icon={<EaTakeover />}
        icons={icons}
        iconsColumnGap={110}
      />
      <ProductScreenTabs
        tabs={tabs}
        badge={{
          color: 'primary',
          title: 'TAKE CENTRE STAGE',
          titleFontSize: 24,
          titleLineHeight: '1.1',
          titleFontSizeMob: 16,
          x: 0,
        }}
        aspectRatio="821 / 683"
        negMargin={70}
        maxW={1180}
        breakpoint={1280}
        reverse
        smallPrint="Videos should be high resolution, watermark free with a minimum size of 1920x1080."
        smallPrintMt={75}
        pb={15}
        button={{
          onClick: () => document.getElementById('contact-us')?.scrollIntoView({ behavior: 'smooth' }),
          text: 'Contact us',
          containerStyle: { maxWidth: '280px' },
        }}
        buttonXPadding={20}
        staticTabs
        mockup={TakeoverMockup}
        tabsMt={-15}
        buttonMt={0}
      />
    </>
  );
};

export default HomepageTakeover;
